import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="w-full bg-warmWhite pt-6 pb-8 px-4 md:pt-8 md:pb-10" data-id="element-132">
      <div className="max-w-2xl mx-auto flex flex-col items-center text-center" data-id="element-133">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="font-serif text-3xl md:text-5xl font-bold text-dark leading-tight mb-4" data-id="element-134">
          "Descubrí Por Qué Mi Vientre Seguía Inflamado Sin Importar Lo Que
          Comía — Y No Tenía Nada Que Ver Con Mi Dieta"
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="font-sans text-base md:text-lg text-gray-700 leading-relaxed mb-6 max-w-xl" data-id="element-135">
          El mismo protocolo de 14 días que miles de mujeres están usando para
          desinflamar su vientre, recuperar su energía y finalmente sentirse
          bien en su propio cuerpo — sin pastillas, sin ayunos extremos y sin
          contar calorías.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="w-full max-w-md mb-6 relative" data-id="element-136">
          <div className="absolute inset-0 bg-primary/10 rounded-3xl transform rotate-3 scale-105 -z-10" data-id="element-137"></div>
          <img src="https://cdn.magicpatterns.com/uploads/5jZtauBWy7jRReAWi6FdM1/Higado_-_14_dias_.png" alt="Bundle Hígado Vital" className="w-full h-auto rounded-2xl shadow-xl object-cover" data-id="element-138" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="w-full max-w-md" data-id="element-139">
          <CTAButton data-id="element-140" />
          <p className="mt-4 text-sm text-gray-500 font-sans flex items-center justify-center gap-2" data-id="element-141">
            <span className="w-2 h-2 rounded-full bg-success animate-pulse" data-id="element-142"></span>
            Oferta especial disponible hoy
          </p>
        </motion.div>
      </div>
    </section>;
}